export default __webpack_public_path__ + "static/media/menu_currentsystemreport_selected.4a3994cd.svg";